<template>
  <div>
    <!-- toast -->
    <div
      v-if="showMessage"
      class="toast align-items-center text-bg-danger fade show position-absolute top-0 end-0"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      data-bs-config='{"delay":5000, "autohide":true}'
    >
      <div class="d-flex">
        <div class="toast-body">Parent Deleted Successfuly.</div>
        <button
          type="button"
          class="btn-close me-2 m-auto"
          data-bs-dismiss="toast"
          aria-label="Close"
        ></button>
      </div>
    </div>
    <!-- end toast -->
    <div class="col-lg-12">
      <div class="col-lg-12 table-responsive">
        <div class="progress mb-0 progress-sm" v-if="progress != 0">
          <div
            class="progress-bar"
            role="progressbar"
            :aria-valuenow="progress"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="{ width: progress + '%' }"
          ></div>
        </div>
        <DataTable
          v-if="progress == 0"
          :columns="cols"
          :rows="rows"
          :pageSize="10"
          :actions="{
            view: handleView,
            delete: handleDelete,
          }"
        />
      </div>
    </div>
    <div
      v-if="showModal"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-sm-down"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header ms-1">
            <h5
              class="modal-title color-darknavy"
              id="studentDetailsModalLabel"
            >
              Parent {{ Obj.parent?.fatherName }} Details
            </h5>
            <button
              type="button"
              class="btn-close ms-auto"
              aria-label="Close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body row ms-1 me-1 ps-0">
            <div class="col-md-6">
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start">
                  <strong>Father Name</strong>
                </div>
                <div class="col-md-8 col-6">: {{ Obj.parent?.fatherName }}</div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start">
                  <strong>Mother Name</strong>
                </div>
                <div class="col-md-8 col-6">: {{ Obj.parent?.motherName }}</div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start">
                  <strong>Email</strong>
                </div>
                <div class="col-md-8 col-6">: {{ Obj.parent?.email }}</div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start">
                  <strong>Phone No</strong>
                </div>
                <div class="col-md-8 col-6 text-start">
                  : {{ Obj.parent?.phone }}
                </div>
              </div>
              <div class="row mb-1" v-if="Obj.parent?.altNo">
                <div class="col-6 col-md-4 text-start">
                  <strong>Alternate No</strong>
                </div>
                <div class="col-md-8 col-6 text-start">
                  : {{ Obj.parent?.altNo }}
                </div>
              </div>
              <div class="row mb-1" v-if="Obj.parent.bloodGroup">
                <div class="col-md-4 col-6 text-start">
                  <strong>Blood Group</strong>
                </div>
                <div class="col-md-8 col-6">: {{ Obj.parent?.bloodGroup }}</div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start">
                  <strong>Category</strong>
                </div>
                <div class="col-md-8 col-6 text-start">
                  : {{ Obj.parent?.categoryName }}
                </div>
              </div>
              <div class="row mb-1" v-if="Obj.parent?.aadharPhoto">
                <div class="col-md-4 col-6 text-start">
                  <strong>Aadhar Photo</strong>
                </div>
                <div class="col-md-8 col-6 text-start">
                  :
                  <a
                    :href="getUrl(Obj.parent?.aadharPhoto)"
                    target="_blank"
                    class="clearfix"
                    ><img
                      :src="getUrl(Obj.parent?.aadharPhoto)"
                      class="avatar-sm"
                      alt="Student Image"
                  /></a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mb-1">
                <div class="col-md-5 col-6 text-start">
                  <strong>Father Profession</strong>
                </div>
                <div class="col-md-7 col-6">
                  : {{ Obj.parent?.fatherProfession }}
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-5 col-6 text-start">
                  <strong>Mother Profession</strong>
                </div>
                <div class="col-md-7 col-6">
                  : {{ Obj.parent?.motherProfession }}
                </div>
              </div>
              <div class="row mb-1" v-if="Obj.parent.aadharNumber">
                <div class="col-md-5 col-6 text-start text-nowrap">
                  <strong>Aadhaar Number</strong>
                </div>
                <div class="col-md-7 col-6">
                  : {{ Obj.parent?.aadharNumber }}
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-5 col-6 text-start">
                  <strong>Student</strong>
                </div>
                <div class="col-md-7 col-6" v-if="students.length">
                  <div v-for="(student, idx) in students" :key="idx">
                    <a class="mb-1"
                      >:
                      <RouterLink
                        :to="`/students/add?id=${student._id}`"
                        class="me-2 no-underline text-info fw-bold"
                      >
                        {{ student.firstName }},
                      </RouterLink>
                    </a>
                    {{
                      clsList.find((cls) => cls._id == student.clsID) &&
                      secList.find((sec) => sec._id == student.sectionID)
                        ? `${
                            clsList.find((cls) => cls._id == student.clsID)
                              ?.name
                          } (${
                            secList.find((sec) => sec._id == student.sectionID)
                              ?.Name
                          })`
                        : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-5 col-6 text-start">
                  <strong>Address</strong>
                </div>
                <div class="col-md-7 col-6">: {{ Obj.parent?.address }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-info"
              @click="closeModal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import "datatables.net";
import { useRouter } from "vue-router";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import DataTable from "@/components/Common/DataTable.vue";
import { api } from "@/utils/helpers.js";
import { ref, onMounted, computed } from "vue";
import { schoolStore } from "@/utils/schoolStore";
const { clsList, secList } = schoolStore();
const allData = ref([]);
const uniqueParents = ref([]);
const Obj = ref({});
const showMessage = ref(false);
const showModal = ref(false);
const router = useRouter();
const cols = ref([
  { label: "S.No", key: "SNo" },
  { label: "Father Name", key: "fatherName" },
  { label: "Mother Name", key: "motherName" },
  { label: "Email", key: "email" },
  { label: "Phone", key: "phone" },
  { label: "Category", key: "categoryID" },
  { label: "Religion", key: "relId" },
]);
const categories = ref([]);

const loadCategories = async () => {
  const res = await api.get("/Category/all");
  categories.value = res.data;
};
const handleView = (row) => {
  Obj.value = {
    ...row,
    parent: {
      ...row.parent,
      categoryName:
        categories.value.find((c) => c._id === row.parent?.categoryID)?.Name ||
        "",
    },
  };
  showModal.value = true;
};
const closeModal = () => {
  showModal.value = false;
};
const rows = ref([]);
const students = computed(() => {
  if (!Obj.value.parent?.fatherName) return [];
  return allData.value.filter(
    (item) => item.parent?._id === Obj.value.parent?._id,
  );
});
const progress = ref(0);
const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get(`/students/search?strat=0&limit=200`).then((response) => {
    const data = response.data.map((item, i) => ({
      ...item,
      SNo: i + 1,
      fatherName: item.parent?.fatherName,
      motherName: item.parent?.motherName,
      phone: item.parent?.phone,
      email: item.parent?.email,
      categoryID:
        categories.value.find((c) => c._id === item.parent?.categoryID)?.Name ||
        "",
      relId: item.parent?.relId,
      bloodGroup: item.parent?.bloodGroup,
      parent: item.parent,
    }));
    allData.value = data;
    const seen = new Set();
    const unique = data
      .filter((item) => {
        const name = item.fatherName?.trim().toLowerCase();
        if (!name || seen.has(name)) return false;
        seen.add(name);
        return true;
      })
      .map((item, index) => ({ ...item, SNo: index + 1 }));
    progress.value = 0;
    clearInterval(progressInterval);
    uniqueParents.value = unique;
    rows.value = unique;
  });
};
const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/default2.png"
    : img.startsWith("..")
    ? img.substring(2)
    : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
};
onMounted(() => {
  loadData();
  loadCategories();
  router.afterEach(() => {
    document.body.classList.remove("modal-open");
    document.body.style = "";
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.remove();
  });
});
</script>
<style>
body.modal-open {
  overflow: auto !important;
  padding-right: 0 !important;
  filter: none !important;
  backdrop-filter: none !important;
}
.modal-backdrop {
  display: none !important;
  opacity: 0 !important;
}
</style>
